import React from "react";
const ProjectCard = () => <section>hey i'm ProjectCard</section>;
export default ProjectCard;
